import React from 'react'

interface QuestionCardProps {
  title: string
  required?: boolean
  children: React.ReactNode
}

const QuestionCard: React.FC<QuestionCardProps> = ({
  title,
  required = false,
  children,
}) => {
  return (
    <div data-question className="bg-background rounded-xl border border-slate-200 p-6 shadow-sm scroll-mt-24">
      <div className="mb-4">
        <h3 className="text-base font-semibold text-slate-900">
          {title}
          {required && <span className="text-red-500 ml-1">*</span>}
        </h3>
      </div>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  )
}

export default QuestionCard
